import React from "react";

export default function TinyCharts2() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_872_20)">
        <circle cx="22" cy="22" r="18" fill="#EAEEF9" />
      </g>
      <path
        d="M22 4C26.2859 4 30.4311 5.52925 33.6901 8.31269C36.9491 11.0961 39.1079 14.9511 39.7784 19.1842C40.4488 23.4173 39.5869 27.7507 37.3475 31.405C35.1082 35.0593 31.6384 37.7946 27.5623 39.119L22 22V4Z"
        fill="url(#paint0_linear_872_20)"
      />
      <defs>
        <filter
          id="filter0_i_872_20"
          x="4"
          y="4"
          width="36"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.211765 0 0 0 0 0.168627 0 0 0 0 0.45098 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_872_20"
          />
        </filter>
        <linearGradient
          id="paint0_linear_872_20"
          x1="22"
          y1="58"
          x2="58"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6006D" />
          <stop offset="1" stopColor="#F7B500" />
        </linearGradient>
      </defs>
    </svg>
  );
}
